import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { seoPages, site } from './registry';

export default function Seo() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    const path = pathname.replace(/\/+$/, '') || '/';
    const page = seoPages.find((entry) => entry.path === path);
    const title = page?.title || 'Page Not Found | Moyer Production Co.';
    const description = page?.description || 'This page is unavailable. Explore Moyer Production Co. photography and video production services.';
    const canonical = `${site.origin}${path === '/' ? '/' : path}`;
    const meta = (attribute, name, content) => {
      let element = document.head.querySelector(`meta[${attribute}="${name}"]`);
      if (!element) { element = document.createElement('meta'); element.setAttribute(attribute, name); document.head.appendChild(element); }
      element.setAttribute('content', content);
    };
    document.title = title;
    meta('name', 'description', description);
    meta('name', 'robots', page ? 'index,follow,max-image-preview:large' : 'noindex,follow');
    for (const [name, value] of Object.entries({ title, description, url: canonical, type: page?.type || 'website', image: new URL(page?.image || site.image, site.origin).href, site_name: site.name })) meta('property', `og:${name}`, value);
    for (const [name, value] of Object.entries({ card: 'summary_large_image', title, description, image: new URL(page?.image || site.image, site.origin).href })) meta('name', `twitter:${name}`, value);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement('link'); link.rel = 'canonical'; document.head.appendChild(link); }
    link.href = canonical;
    let schema = document.head.querySelector('script[type="application/ld+json"]');
    if (!schema) { schema = document.createElement('script'); schema.type = 'application/ld+json'; document.head.appendChild(schema); }
    schema.textContent = JSON.stringify({
      '@context': 'https://schema.org', '@type': page?.type === 'article' ? 'BlogPosting' : 'WebPage',
      name: title, description, url: canonical, image: new URL(page?.image || site.image, site.origin).href,
      ...(page?.publishedAt ? { datePublished: page.publishedAt } : {}),
      publisher: { '@type': 'Organization', name: site.name, url: site.origin },
    });
  }, [pathname]);
  return null;
}
